import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus, { ElDialog } from 'element-plus'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/display.css'
import locale from 'element-plus/es/locale/lang/es'

// Standardize modal overlay behavior across the entire admin:
// Default appendToBody to true so that every ElDialog teleports to document.body
// and the blurred backdrop covers the entire viewport (header, sidebar, content).
if (ElDialog?.props?.appendToBody) {
  (ElDialog.props.appendToBody as any).default = true
}

import App from './App.vue'
import router from './router'
import './sass/site.scss'
import 'font-awesome/css/font-awesome.css'
import '../public/css/appmisionate-design-system.css'
import './styles/website-landing.css'
// Unicons servido localmente (el CDN unicons.iconscout.com devolvía 403 y quedaba
// bloqueado por ORB, dejando todos los iconos uil-* sin renderizar).
import './styles/unicons.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

const app = createApp(App)
const pinia = createPinia()

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// Map legacy Element UI icon names to Element Plus icons
const iconAliases: Record<string, any> = {
  'el-icon-circle-plus': ElementPlusIconsVue.CirclePlus,
  'el-icon-circle-plus-outline': ElementPlusIconsVue.CirclePlus,
  'el-icon-plus': ElementPlusIconsVue.Plus,
  'el-icon-minus': ElementPlusIconsVue.Minus,
  'el-icon-search': ElementPlusIconsVue.Search,
  'el-icon-arrow-down': ElementPlusIconsVue.ArrowDown,
  'el-icon-arrow-up': ElementPlusIconsVue.ArrowUp,
  'el-icon-arrow-left': ElementPlusIconsVue.ArrowLeft,
  'el-icon-arrow-right': ElementPlusIconsVue.ArrowRight,
  'el-icon-upload': ElementPlusIconsVue.Upload,
  'el-icon-download': ElementPlusIconsVue.Download,
  'el-icon-edit': ElementPlusIconsVue.Edit,
  'el-icon-delete': ElementPlusIconsVue.Delete,
  'el-icon-close': ElementPlusIconsVue.Close,
  'el-icon-check': ElementPlusIconsVue.Check,
  'el-icon-more': ElementPlusIconsVue.More,
  'el-icon-setting': ElementPlusIconsVue.Setting,
  'el-icon-user': ElementPlusIconsVue.User,
  'el-icon-time': ElementPlusIconsVue.Clock,
  'el-icon-date': ElementPlusIconsVue.Calendar,
  'el-icon-view': ElementPlusIconsVue.View,
  'el-icon-refresh': ElementPlusIconsVue.Refresh,
  'el-icon-warning': ElementPlusIconsVue.Warning,
  'el-icon-info': ElementPlusIconsVue.InfoFilled,
  'el-icon-question': ElementPlusIconsVue.QuestionFilled,
  'el-icon-loading': ElementPlusIconsVue.Loading
}

for (const [alias, comp] of Object.entries(iconAliases)) {
  if (comp) {
    app.component(alias, comp)
  }
}


import DateTimeService from './core/shared/services/DateTimeService'

const formatDateFn = (date: any, format = 'DD/MM/YYYY') => {
  return DateTimeService.formatDate(date, undefined, format)
}

app.config.globalProperties.formatDate = formatDateFn
app.config.globalProperties.$filters = { formatDate: formatDateFn }
app.config.globalProperties.$set = (target: any, key: string, value: any) => {
  if (target) {
    target[key] = value
  }
  return value
}

app.use(pinia)
app.use(router)
app.use(ElementPlus, { locale })

app.mount('#app')

